// extracted by mini-css-extract-plugin
export var body = "_kw-0";
export var sectionHeader = "_kw-4";
export var shortcutColumns = "_kw-2";
export var shortcutList = "_kw-1";
export var shortcutSection = "_kw-3";